import React from 'react';
import { faBomb } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const BombIcon = ({ toolTipText = 'Delete All' }) => (
  <Icon tooltip={toolTipText} iconObj={faBomb} />
);

export default BombIcon;